module.exports = __webpack_public_path__ + "img/send-button.2845846d.svg";